import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import OrderArticleInfo from './OrderArticleInfo'
import OrderPaletInfo from './OrderPaletInfo'
import OrderState from './OrderState'

export default function Order(props) {
    const classes = useStyles();

   
    return <div className={classes.orderContainer}>
        <div className={classes.coloredBorder} style={{ backgroundColor: props.productionOrder.productionOrderStatusForegroundColor }}></div>
        <OrderState productionOrder={props.productionOrder} {...props}></OrderState>
        <OrderArticleInfo productionOrder={props.productionOrder} {...props}></OrderArticleInfo>
        <OrderPaletInfo productionOrder={props.productionOrder} {...props}></OrderPaletInfo>
    </div>
}

const useStyles = makeStyles({
    orderContainer: {
        backgroundColor: "white",
        borderRadius: "6px",
        height: '165px',
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)"

    },
    coloredBorder: {
        float: "left",
        width: "7px",
        height: "165px",
        borderRadius: "6px 0px 0px 6px",
        opacity: "0.28",
    }

});